import React from 'react';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import SearchableListModal from '@gumtree/ui-library/src/searchable-list-modal/searchable-list-modal';

import { computeListingDetails } from '../../../services/syi-model';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

export type AttributeStateClientSide = {
    selectedValue: string | undefined;
    selectedDisplayName: string | undefined;
    isInvalid?: boolean;
    hasSelected?: boolean;
};

export type AttributeStateServerSide = {
    description: null;
    displayLabel: boolean;
    id: string;
    label: string;
    mandatory: boolean;
    selectedValue: { present: boolean };
    type: string;
    values: {
        disabled: boolean;
        displayValue: string;
        selected: boolean;
        value: string;
    }[];
    placeholder?: string;
};

export type SelectModelProps = AttributeStateClientSide &
    AttributeStateServerSide & {
        saveChanges?: (value, displayValue) => any;
    };

export default function SelectAttributeModel(props: SelectModelProps) {
    const {
        label,
        id,
        mandatory,
        values,
        selectedValue,
        selectedDisplayName,
        isInvalid,
        saveChanges,
        placeholder,
    } = props;
    const ga4EventSearch = () =>
        trackGA4Event<GA4.PostAdInteractionEvent>({
            event: 'ad_posted_form_interactions',
            formName: 'syi-form',
            formStep: `change attribute[${id} search]`,
            ...computeListingDetails(),
        });
    if (!label || !id) {
        return null;
    }
    const displayName =
        selectedDisplayName ||
        values.find((i) => i.value && i.value === selectedValue)?.displayValue;
    return (
        <div className="form-element" key={id}>
            <SearchableListModal
                fieldTitle={label}
                mandatory={mandatory}
                modalTitle={`Select the ${label}`}
                placeholder={`Search for the ${label}`}
                triggerText={placeholder ? placeholder : `Select your ${label}`}
                listTitle={`All ${label}`}
                listData={(values ?? []).slice(1)}
                listName={`attributes[${id}]`}
                elName={id}
                selectedValue={selectedValue}
                selectedDisplayName={displayName}
                isInvalid={isInvalid ?? false}
                ga4EventSearch={() => ga4EventSearch()}
                saveChanges={saveChanges ? saveChanges : () => {}}
                searchable={(values ?? []).length > 30}
            />
            <input
                type="text"
                className="hide-visually"
                name={`attributes[${id}]`}
                value={selectedValue ?? ''}
                onChange={() => {}} // No-op to ensure controlled input
                data-validation-rules={mandatory ? 'isNotEmpty' : ''}
                data-validation-group-channel="phones-group"
                required
                aria-required={mandatory ? 'true' : 'false'}
                autoComplete="off"
            />
            {isInvalid && (
                <ul className="form-element-errors" {...qaAttribute(`panel-${id}-error`)}>
                    <li> Please select a {label}</li>
                </ul>
            )}
        </div>
    );
}
